var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show && _vm.options)?_c(_vm.options.component,_vm._g(_vm._b({tag:"component",on:{"close-current-eum-modal":_vm.closeModal},model:{value:(_vm.options.vmodel),callback:function ($$v) {_vm.$set(_vm.options, "vmodel", $$v)},expression:"options.vmodel"}},'component',_vm.options.vbind,false),_vm.options.vevent)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }